import { render } from "./CorporateMainVisual.vue?vue&type=template&id=5fd71a23&scoped=true"
const script = {}

import "./CorporateMainVisual.vue?vue&type=style&index=0&id=5fd71a23&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd71a23"]])

export default __exports__